import "./Header.scss";
import { useState } from "react";
import logo from "../../Assets/image (63).png";
import user from "../../Assets/user.png";
import { BsBell, BsCart2, BsGear } from "react-icons/bs";
import { Link } from "react-router-dom";
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar__logo">
        <img src={logo} width={40} alt="Logo" />
      </div>

      <div className="navbar__placeholder" >
        <p style={{color:"white"}}>12th January of 2024, 12:00 pm</p>
      </div>

      <div className="navbar__search">
        <input
          type="text"
          placeholder="Search by order id"
          className="search"
        />
        <i className="fa-solid fa-magnifying-glass search__icon"></i>
      </div>

      <div className={`navbar__links ${isOpen ? "open" : ""}`}>
        <div>
        <BsBell className="icon"/>
        </div>
    <div>
    <BsCart2 className="icon" />
    </div>
     <div>

     <BsGear className="icon" />
     </div>
        <div className="line"></div>
        <img src={user} className="user-img" alt="User" width={30} />
        <Link to="/dashboard/Profile" className=" list-unstyled">
            <div className="info">
          <h3>Osama</h3>
          <span>Manager</span>
        </div>
        </Link>
    
      </div>

      <div className="navbar__toggle" onClick={() => setIsOpen(!isOpen)}>
        &#9776;
      </div>
    </nav>
  );
};

export default Navbar;
